import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  /**
   * Optional icon to render inside the thumb
   */
  thumbIcon?: React.ReactNode;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, thumbIcon, checked, ...props }, ref) => {
  return (
    <SwitchPrimitives.Root
      className={cn(
        "peer inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-[2.28125rem] border border-gray-100 p-[2px] transition-colors bg-gray-50",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      checked={checked}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          "pointer-events-none flex items-center justify-center size-4 rounded-[0.75rem] shadow-[1px_1px_2px_-1px_rgba(51,51,51,0.3)] ring-0 transition-all",
          "data-[state=unchecked]:bg-white data-[state=unchecked]:translate-x-0",
          "data-[state=checked]:bg-gray-500 data-[state=checked]:translate-x-5"
        )}
      >
        {thumbIcon && (
          <span className={cn(
            "flex items-center justify-center transition-colors",
            checked ? "text-white" : "text-gray-300"
          )}>
            {thumbIcon}
          </span>
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  )
})
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
